import { Button } from '@omni/ui'
import { Lock } from 'lucide-react'
import type { Surface } from '../surfaces'
import { DEFAULT_SURFACE_PATH } from '../surfaces'
import { workspace } from '../lib/config'
import { shellNavigate } from '../lib/navigation'

/**
 * Rendered when the path belongs to a real surface that is not in this
 * instance's modules. A small branded panel — never a blank page, never a
 * crash, never a silent redirect (no-silent-null rule).
 */
export function DisabledModule({ surface }: { surface: Surface }) {
  return (
    <div className="flex h-full w-full items-center justify-center bg-surface-0">
      <div className="w-full max-w-sm rounded-2xl border border-border bg-surface-1 p-8 text-center shadow-sm">
        <div
          className="mx-auto mb-5 flex h-12 w-12 items-center justify-center rounded-xl text-white"
          style={{ background: 'var(--gradient-brand)' }}
        >
          <Lock className="h-5 w-5" />
        </div>
        <h1 className="text-lg font-semibold text-text-primary">
          This module isn&rsquo;t part of your workspace
        </h1>
        <p className="mt-2 text-sm text-text-secondary">
          {surface.meta.label} isn&rsquo;t enabled for {workspace.label}.{' '}
          {import.meta.env.VITE_INSTANCE_SLUG === 'mortgage-man'
            ? 'If you think it should be, mention it to Sam.'
            : 'If you think it should be, talk to your Omni administrator.'}
        </p>
        <div className="mt-6">
          <Button onClick={() => shellNavigate(DEFAULT_SURFACE_PATH)}>
            Back to {workspace.label}
          </Button>
        </div>
      </div>
    </div>
  )
}
